module.exports = __webpack_public_path__ + "src/assets/img/engine_three.e79464f3.svg";